module.exports = __webpack_public_path__ + "static/favicon-db400e577103712f650ebe414e216229.png";